import Swal from 'sweetalert2';

const baseOptions = {
  confirmButtonColor: '#1E6370',
  cancelButtonColor: '#b43737',
  reverseButtons: true,
  customClass: {
    popup: 'portal-swal',
    confirmButton: 'portal-swal-confirm',
    cancelButton: 'portal-swal-cancel',
  },
  buttonsStyling: false,
};

export function confirmDialog({ title, text, confirmButtonText = 'Confirmar', cancelButtonText = 'Cancelar' }) {
  return Swal.fire({
    ...baseOptions,
    icon: 'warning',
    title,
    text,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
  });
}

export function successAlert({ title, text }) {
  return Swal.fire({
    ...baseOptions,
    icon: 'success',
    title,
    text,
    confirmButtonText: 'Fechar',
  });
}

export function errorAlert({ title, text }) {
  return Swal.fire({
    ...baseOptions,
    icon: 'error',
    title,
    text,
    confirmButtonText: 'Fechar',
  });
}
